export const RECEIVE_ZONES = 'RECEIVE_ZONES';
export const GET_ZONES = 'GET_ZONES';
export const SET_ZONE = 'SET_ZONE';
export const UPDATE_ZONE = 'UPDATE_ZONE';
export const DELETE_ZONE = 'DELETE_ZONE';
export const FETCH_ZONES = 'FETCH_ZONES';
